<template lang="pug">
#bloco-informacao-skeleton
    el-skeleton.el-skeleton(:loading='carregando', animated)
        template(slot='template')
            .skeleton-bloco-infor-dados-gestao-interno
                el-skeleton-item.dado-icone(variant='circle')

                .dado-titulo.width-interno
                    el-skeleton-item(variant='p')
                    el-skeleton-item.width-interno(variant='p')

                el-skeleton-item.dado-numero(variant='rect')
        template
            slot
</template>

<script>
export default {
    name: 'BlocoInformacaoSkeleton',
    props: {
        carregando: {
            type: Boolean,
            default: () => false
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-informacao-skeleton {
    .width-interno {
        width: 50%;
    }

    .skeleton-bloco-infor-dados-gestao-interno {
        min-height: 89px;
        min-width: 19vw;
        border-radius: 10px;
        background: #d6d6d6;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .dado-icone {
            width: 28px;
            height: 28px;
        }
        .dado-titulo {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 6px;
        }
        .dado-numero {
            width: 10%;
            height: 30px;
        }
    }
}
</style>
